import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    useTheme,
    IconButton,
} from "@mui/material";
import { addOwner, updateOwner } from "state/apis";
import { toast } from "react-toastify";
import { Close as CloseIcon } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
const AddOwnerForm = ({ open, onClose, onSubmit, editData, editMode }) => {
    const theme = useTheme();
    const [ownerData, setOwnerData] = useState({
        name: "",
        arabicName: "",
        mobile: "",
        address: "",
        docs: [],
    });

    useEffect(() => {
        if (editMode && editData) {
            setOwnerData((prevData) => ({
                ...prevData,
                name: editData.name,
                arabicName: editData.arabicName,
                mobile: editData.mobile,
                address: editData.address,
            }));
        } else {
            setOwnerData({
                name: "",
                arabicName: "",
                mobile: "",
                address: "",
                docs: [],
            });
        }
    }, [editData, editMode]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setOwnerData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleAddDocument = () => {
        setOwnerData((prevData) => ({
            ...prevData,
            docs: [...prevData.docs, { name: "", file: null }],
        }));
    };

    const handleDocumentNameChange = (index, value) => {
        const updatedDocuments = [...ownerData.docs];
        updatedDocuments[index].name = value;
        setOwnerData((prevData) => ({
            ...prevData,
            docs: updatedDocuments,
        }));
    };

    const handleCancelDocument = (indexToRemove) => {
        setOwnerData((prevState) => ({
            ...prevState,
            docs: prevState.docs.filter((_, index) => index !== indexToRemove),
        }));
    };
    const handleDocumentFileChange = (index, file) => {
        const updatedDocuments = [...ownerData.docs];
        updatedDocuments[index].file = file;
        setOwnerData((prevData) => ({
            ...prevData,
            docs: updatedDocuments,
        }));
    };

    const handleSubmit = async () => {
        try {
            if (editMode) {
                const response = await updateOwner(editData?.id, ownerData);
                toast.success(response.message);
            } else {
                const response = await addOwner(ownerData);
                toast.success(response.message);
            }
            onSubmit();
            onClose();
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            {/* <DialogTitle sx={{ textAlign: "center", fontWeight: "900", mb: "2px" }}>
                {editMode ? "Edit Owner" : "Add Owner"}
            </DialogTitle> */}
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                {editMode ? "Edit Owner" : "Add Owner"}
                <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Name"
                            name="name"
                            value={ownerData.name}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Arabic Name"
                            name="arabicName"
                            value={ownerData.arabicName}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Mobile"
                            name="mobile"
                            value={ownerData.mobile}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Address"
                            name="address"
                            value={ownerData.address}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} m={2} border={1} p={2} sx={{ borderColor: "grey.400" }}>
                        <Grid container alignItems="center">
                            <Grid item xs={8}>
                                <label>Owner Documents</label>
                            </Grid>
                            <Grid item xs={4} container justifyContent="flex-end">
                                <Button variant="contained" onClick={handleAddDocument}>
                                    Add Document
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            {ownerData?.docs?.map((document, index) => (
                                <Grid container spacing={2} key={index} p={1}>
                                    <Grid item xs={5}>
                                        <TextField
                                            fullWidth
                                            color="primary"
                                            label="Document Name"
                                            value={document.name}
                                            onChange={(e) =>
                                                handleDocumentNameChange(index, e.target.value)
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={5} margin={"auto"}>
                                        <input
                                            type="file"
                                            accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            onChange={(e) =>
                                                handleDocumentFileChange(index, e.target.files[0])
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={2} container justify="end" margin="auto">
                                        <IconButton
                                            color="error"
                                            onClick={() => handleCancelDocument(index)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>

                <DialogActions>
                    {/* <Button
                        variant="contained"
                        onClick={onClose}
                        sx={{
                            color: theme.palette.primary,
                            backgroundColor: theme.palette.primary[800],
                        }}
                    >
                        Cancel
                    </Button> */}
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        {editMode ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default AddOwnerForm;
